export const betslipZIndex = 999;
export const zendeskZIndex = 1201;
